import {createContext} from 'react';

import {ListMode} from 'client/common/store/reducers/surveys/types';

export default createContext(ListMode.User);
